import { Button } from "frontend-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { AVAILABLE_WIDGETS } from "./constants/widgets";
import { useTranslation } from "react-i18next";

interface WidgetGridItemProps {
    widgetId: string;
    isCustomizing: boolean;
    onRemove: (widgetId: string) => void;
    fill?: boolean;
}

export function WidgetGridItem({
    widgetId,
    isCustomizing,
    onRemove,
    fill = true,
}: WidgetGridItemProps) {
    const { t } = useTranslation();

    const widget = AVAILABLE_WIDGETS.find((w) => w.id === widgetId);
    if (!widget) return null;
    const Component = widget.component;

    return (
        <div
            className={`relative min-w-0 transition-all duration-75 ${
                fill ? "h-full" : ""
            } ${isCustomizing ? "hover:ring-2 hover:ring-chameleon-green/60 rounded-[3px]" : ""}`}
        >
            {isCustomizing && (
                <Button
                    type="button"
                    variant="fill"
                    size="icon-sm"
                    onClick={() => onRemove(widgetId)}
                    aria-label={t("dashboard.remove")}
                    className="absolute top-2 right-2 z-10"
                >
                    <FontAwesomeIcon icon={faXmark} />
                </Button>
            )}

            <Component />
        </div>
    );
}
